import {useEffect, useState, useMemo} from 'react';
import i18n from 'i18next';
import {languageOptions} from 'utils/i18n/constants';

function useCurrentLanguage() {
  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      setLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  const config = useMemo(() => {
    return languageOptions.find(option => option.value === language);
  }, [language]);

  return config;
}

export {useCurrentLanguage};
